module.exports = {
    LOGO: 'LOGO',
    ADVERTISEMENT: 'ADVERTISEMENT',
    MENU: 'MENU',
    FOODIE: 'FOODIE_PHOTOS',
    PROMO: 'PROMO',
    BUSINESS: 'BUSINESS',
    REGISTRATION: 'REGISTRATION',
    EVENT: 'EVENT',
    FAVICON: 'FAV_ICON'
  };